import { TCategorySidebar } from '../types';
import { Api, TResponse } from '@/modules/common';

export const editorServices = {
  apiGetElements: (): Promise<TResponse<TCategorySidebar[]>> => {
    return Api.base.get(`api/snippets/v2`);
  },
};
